import styled, { css } from 'styled-components';

interface OverlayProp {
  $withOverlay?: boolean;
}

interface DotProp {
  $active?: boolean;
}

export const Wrapper = styled.div`
  position: relative;
`;

export const ControlsArea = styled.div``;

export const ArrowButton = styled.button`
  background: transparent;
  border: none;
  padding: 0.25rem;
  cursor: pointer;
`;

export const DotContainer = styled.div<OverlayProp>`
  ${props =>
    props.$withOverlay &&
    css`
      background-color: #f2f2f2;
      padding: 0.5rem 1rem;
      border-radius: 2rem;
    `}
`;

export const Dot = styled.div<DotProp>`
  width: 0.625rem;
  height: 0.625rem;
  margin: 0 0.25rem;
  border-radius: 50%;
  background-color: ${props => (props.$active ? '#000' : '#ccc')};
`;

export const BarContainer = styled.div<OverlayProp>`
  position: relative;
  width: 100%;
  height: 0.5rem;
  background-color: #ccc;
  border-radius: 0.25rem;
  ${props =>
    props.$withOverlay &&
    css`
      background-color: #f2f2f2;
      padding: 0.25rem 0.5rem;
      border-radius: 1rem;
    `}
`;

export const BarFill = styled.div`
  height: 100%;
  background-color: #000;
  border-radius: 0.25rem;
`;
